import { Tooltip as AntdTooltip } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

import { vars } from '~/theme';

export const Container = styled.div({
  display: 'flex',
  gap: '50rem',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const Description = styled.span({
  fontSize: '14rem',
});

export const Tooltip = styled(AntdTooltip)(({ theme }) => ({
  display: 'inline-flex',
  gap: '3rem',

  color: theme.card.primary.ratingStars,

  '--antd-arrow-background-color': '#fff !important',
}));

export const TooltipArrowStyle = createGlobalStyle(({ theme }) => ({
  '.materials-tooltip': vars({
    '--antd-arrow-background-color': `${theme.palette.white} !important`,
  }),
  '.materials-tooltip .ant-tooltip-arrow': {
    bottom: '1rem !important',
  },
}));
